import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'
import type { LmsTrainingPlain } from 'src/interfaces/collectStepReference'
import { LmsTrainingForm } from './LmsTrainingForm'
import type { LmsTrainingFormMode, LmsTrainingFormValues } from './LmsTrainingForm.interface'

const FORM_ID = 'lms-training-form'

interface Props {
  isOpen: boolean
  mode: LmsTrainingFormMode
  lmsTraining: LmsTrainingPlain | null
  isSaving: boolean
  onSubmit(values: LmsTrainingFormValues): void
  onClose(): void
}

const LmsTrainingFormModalComponent = ({
  isOpen,
  mode,
  lmsTraining,
  isSaving,
  onSubmit,
  onClose,
}: Props) => {
  return (
    <CommonModal
      isOpen={isOpen}
      title={mode === 'edit' ? 'Edit course' : 'Add course'}
      // Wider than the default confirm-dialog width: this modal carries a form.
      className={tw`max-w-[480px]`}
      onClose={onClose}
      buttons={
        <Fragment>
          {/* Disabled while the request is in flight so the control matches the page's
              dismissal guard — a Cancel that looks clickable but does nothing is worse. */}
          <Button size="small" color="grey" disabled={isSaving} onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            color="dark"
            type="submit"
            form={FORM_ID}
            loading={isSaving}
            disabled={isSaving}
            data-testid="lms-training-form-submit-button"
          >
            {mode === 'edit' ? 'Save changes' : 'Create course'}
          </Button>
        </Fragment>
      }
    >
      <LmsTrainingForm formId={FORM_ID} mode={mode} lmsTraining={lmsTraining} onSubmit={onSubmit} />
    </CommonModal>
  )
}

export const LmsTrainingFormModal = memo(LmsTrainingFormModalComponent)
